import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import routePaths from "../../routes/routePaths";
import DesktopNavMenu from "./DesktopNavMenu";
import UserMenu from "../user/UserMenu";
import LanguageSwitch from "./LanguageSwitch";
import HeaderMobile from "./HeaderMobile";
import { useAuth } from "../../contexts/AuthContext";

const Header = () => {
  const { t } = useTranslation();
  const { user, userExt } = useAuth();

  const menuItems = [
    { label: t("menu.home"), to: routePaths.home },
    { label: t("menu.about"), to: routePaths.about },
    { label: t("menu.programs"), to: routePaths.programs },
    { label: t("menu.schedule"), to: routePaths.schedule },
    {
      label: t("menu.resources"),
      to: routePaths.resources || "#",
      subMenuItems: [
        { label: t("menu.testList"), to: routePaths.testList },
        { label: t("menu.teachers"), to: routePaths.teachers },
        { label: t("menu.results"), to: routePaths.results },
      ],
    },
    { label: t("menu.contact"), to: routePaths.contact },
  ];

  return (
    <header className="fixed top-0 left-0 w-full bg-card border-b border-border shadow z-50">
  {/* Desktop Header: Chỉ hiển thị trên md trở lên */}
  <div className="hidden md:flex max-w-7xl mx-auto px-4 py-3 items-center justify-between relative">
    {/* Logo - chỉ desktop */}
    <Link to={routePaths.home} className="flex items-center gap-2 shrink-0">
      <img
        src="/logo.png"
        alt="Quyenxd English Class"
        className="h-10 w-auto sm:h-12 rounded bg-white shadow-sm p-1"
      />
    </Link>
    {/* Desktop Menu */}
    <nav className="flex overflow-x-auto whitespace-nowrap no-scrollbar">
      <DesktopNavMenu menuItems={menuItems} />
    </nav>
    {/* Language & user menu desktop */}
    <div className="flex items-center ml-4 gap-3 shrink-0">
      <LanguageSwitch />
      <UserMenu
        user={user}
        userRoles={userExt?.roles}
        avatar={userExt?.avatar}
      />
    </div>
  </div>

  {/* Mobile Header: Chỉ hiển thị dưới md */}
  <div className="md:hidden w-full">
    <HeaderMobile
      menuItems={menuItems}
      user={user}
      avatar={userExt?.avatar}
      userRole={userExt?.roles}
    />
  </div>
</header>

  );
};

export default Header;
